export const localeMap = {
    "en-GB": "en",
    "en-US": "en",
    "zh-CN": "zh",
}